/*
 * @Author: LiuMeiYu
 * @Date: 2023-01-12 16:21:32
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-03-14 10:34:24
 * @FilePath: \nivara\src\http\index.js
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
 */
import axios from "axios"
import router from './../router/index';
// import store from "../store";
import { nextTick } from 'vue';
import {
    ElMessage
} from "element-plus";

function debounce(fn, wait) {
    var timerId = null;
    console.log(timerId);
    let flag = true;
    return function () {
        // clearTimeout(timerId);
        if (flag) {
            fn.apply(this, arguments);
            flag = false;
            timerId = setTimeout(() => {
                flag = true;
            }, wait);
        }
    };
}

const authError = debounce(message => {
    ElMessage({
        message,
        type: "error",
        duration: 3 * 1000
    });
}, 3000);


const instance = axios.create({
    baseURL: (window.location.href.indexOf('uat') != -1) ? 'https://api-uat.giftcard8.com/' : (window.location.href.indexOf('cardswap.top') != -1) ? "https://api.cardswap.top" : "https://139.159.231.112:8080/",
    timeout: 5000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: {
        token: localStorage.getItem("token"),
    }
});

// 添加请求拦截器
instance.interceptors.request.use(config => {
    // 在发送请求之前做些什么
    return config;
}, error => {
    // 对请求错误做些什么
    ElMessage({
        message: error,
        type: "error",
        center: true
    });
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response

}, function (error) {
    // // 对响应错误做点什么
    if (error && error.response) {
        console.log(error.response);

        switch (error.response.status) {

            case 400: error.message = '请求错误(400)'; break;

            case 401:
                authError("Token is no longer valid, please log in again");
                localStorage.removeItem("token");
                localStorage.removeItem("country_id");
                localStorage.removeItem("currency_name");
                localStorage.removeItem("userId");
                localStorage.removeItem("userInfo");
                nextTick(() => {
                    router.push({ path: '/login', query: { redirect: router.currentRoute.value.fullPath } });
                });
                break;

            case 403: error.message = '拒绝访问(403)'; break;

            case 404: error.message = '请求出错(404)'; break;

            case 408: error.message = '请求超时(408)'; break;

            case 500: error.message = '服务器错误(500)'; break;

            case 501: error.message = '服务未实现(501)'; break;

            case 502: error.message = '网络错误(502)'; break;

            case 503: error.message = '服务不可用(503)'; break;

            case 504: error.message = '网络超时(504)'; break;

            case 505: error.message = 'HTTP版本不受支持(505)'; break;

            default: error.message = `连接出错(${error.response.status})!`;
        }
    } else {
        error.message = '连接服务器失败!'
    }
    return Promise.reject(error)
});

export default instance